'use client';
import styled from 'styled-components';
import { Steps } from '../CheckoutHeader/styles';

export const Wrapper = styled.div`
  width: 100vw;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.base};
  ${Steps} {
    width: 100%;
  }
  @media ${({ theme }) => theme.tablet} {
    overflow: auto;
  }
`;

export const Headline = styled.h4`
  ${({ theme }) => theme.typography.heading4}
  ${({ theme }) => theme.fontFamily.condensed}
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  margin: ${({ theme }) => theme.spacing(2)};
`;

export const HeaderContainer = styled.div`
  text-align: center;
  padding: ${props => props.theme.spacing(2)};

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(3, 0)};
  }
`;

export const FullHeadline = styled.h1`
  ${({ theme }) => theme.typography.heading3}
`;

export const FullSubheadline = styled.p`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.primary};

  margin: ${props => props.theme.spacing(2)} auto 0;
  padding-top: ${props => props.theme.spacing(2)};
`;

export const ProductCardContainer = styled.div`
  max-width: 100%;
  @media ${({ theme }) => theme.tablet} {
    max-width: 360px;
    margin: auto;
  }
`;

export const Subheadline = styled.h3`
  ${({ theme }) => theme.typography.heading3}
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const BodyText = styled.p`
  ${({ theme }) => theme.typography.body}
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
  @media ${({ theme }) => theme.tablet} {
    text-align: left;
    margin: 0;
  }
`;
export const LinkWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing(3, 0, 5)};
`;
export const StyledRecommendedPlanContainer = styled.div`
  padding: 0 5px;
  margin-bottom: ${({ theme }) => theme.spacing(34)};
  @media ${({ theme }) => theme.mobileM} {
    padding: 0;
    margin-bottom: ${({ theme }) => theme.spacing(17)};
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    min-width: unset;
  }
  legend {
    ${({ theme }) => theme.typography.heading5}
    margin: 0 auto ${({ theme }) => theme.spacing(5)};
  }
`;

export const StyledRecommendedPlanCard = styled.div`
  background-color: ${({ theme }) => theme.colors.background.lightest};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 708px;
  min-width: 315px;
  border-radius: 32px;
  margin: 0 auto ${({ theme }) => theme.spacing(5)};
  padding: ${({ theme }) => theme.spacing(4, 5, 10)};
  @media ${({ theme }) => theme.tablet} {
    padding: ${({ theme }) => theme.spacing(4, 10, 3)};
  }
`;

export const StyledForm = styled.form``;

export const CustomizePlanContainer = styled.div`
  background-color: ${props => props.theme.colors.neutral.bone};
  border-radius: ${props => props.theme.spacing(8)};
  margin: auto;
  margin-top: ${props => props.theme.spacing(6)};
  max-width: 360px;
  min-height: 270px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  padding: ${props => props.theme.spacing(4, 13, 6, 14)};
  ${props => props.theme.typography.heading4}
  @media ${({ theme }) => theme.tablet} {
    max-width: 365px;
  }
`;

export const PlanContainer = styled.div`
  position: relative;
  background-color: ${props => props.theme.colors.background.lightest};
  border-radius: ${props => props.theme.spacing(8)};
  max-width: 360px;
  padding: ${props => props.theme.spacing(4, 4, 6)};
  margin: auto;
  margin-bottom: ${props => props.theme.spacing(6)};
  @media ${({ theme }) => theme.tablet} {
    max-width: 365px;
  }
`;

export const PlanTitle = styled.h4`
  ${props => props.theme.typography.heading4}
  margin:${props => props.theme.spacing(4, 2, 1)}
`;

export const PlanDescription = styled.div`
  margin: ${props => props.theme.spacing(1, 2)};
`;

export const Badge = styled.div`
  position: absolute;
  top: -15px;
  left: 0;
  @media ${({ theme }) => theme.tablet} {
    top: -15px;
    left: -20px;
  }
`;

export const PricesContainer = styled.div`
  margin-left: ${props => props.theme.spacing(2)};
`;

export const StrikeThroughPrice = styled.span`
  ${({ theme }) => theme.typography.body}
  ${({ theme }) => theme.fontFamily.base}
  margin-right: ${({ theme }) => theme.spacing(2)};
  text-decoration-line: line-through;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.status.successPrimary};
`;

export const DisplayedPrice = styled.span`
  ${({ theme }) => theme.typography.bodyBold}
  ${({ theme }) => theme.fontFamily.base}
	margin-right: ${({ theme }) => theme.spacing(1)};
`;
